<template>
	<div>
		<div class="flex xs-12 container-top-bar-wrapper">
			<!-- Wrapper -->
			<div class="flex xs-12 xs-right xs-middle pr2">
				<!-- <p class="fs4 c1 mr2">{{ username }}</p> -->
				<!-- My Account -->
				<j-button
					type="quaternary"
					:to="`/${$route.params.tenantId}/account/detail`"
					class="p4 xs-middle"
					action="account"
				>
					<crm-icon name="account" class="mr1" color="c2" />
					{{ username ? username : "Account" }}
				</j-button>

				<!-- Notifications popover for desktop -->
				<div v-if="$store.state.settings.devFlags.hasNotifications">
					<v-popover
						class="ml2"
						placement="bottom"
						popoverClass="xs-12 r2"
						popoverArrowClass="xs-0"
						popoverInnerClass="xs-12 r2 bg5 b1 bc7"
					>
						<div class="flex">
							<j-button type="bordered">
								<crm-icon name="notifications" color="c2" />
							</j-button>
							<div
								v-if="numberOfUnreadNotifications"
								class="fs3 fw7 notifications-number"
							>
								{{ numberOfUnreadNotifications }}
							</div>
						</div>
						<template slot="popover">
							<div class="bb1 bc7 flex p2 xs-center xs-middle">
								<j-button
									type="tertiary"
									@click="$modal.show('manageSubscriptionsModal')"
								>
									{{ $t("manage_subscriptions") }}
								</j-button>
							</div>
							<notifications-list
								:listing="listing"
								:items-per-page="itemsPerPage"
								:page="page"
								@refetch:unread="fetchNumberOfUnread"
								@refetch:list="fetchNotifications"
								@next-page="page++"
								@previous-page="page--"
							/>
						</template>
					</v-popover>
				</div>
			</div>
		</div>

		<!-- Notifications popover on mobile -->
		<v-popover
			v-if="$store.state.settings.devFlags.hasNotifications"
			class="ml2 notifications-floating-button"
			placement="top"
			popoverClass="xs-12 r2 mb6"
			popoverArrowClass="xs-0"
			popoverInnerClass="xs-12 r2 bg5 b1 bc7"
		>
			<div class="flex">
				<crm-icon name="notifications" color="c2" />
				<div
					v-if="numberOfUnreadNotifications"
					class="fs3 fw7 notifications-number"
				>
					{{ numberOfUnreadNotifications }}
				</div>
			</div>
			<template slot="popover">
				<div class="bb1 bc7 flex p2 xs-center xs-middle">
					<j-button
						type="tertiary"
						@click="$modal.show('manageSubscriptionsModal')"
					>
						{{ $t("manage_subscriptions") }}
					</j-button>
				</div>
				<notifications-list
					:listing="listing"
					:items-per-page="itemsPerPage"
					:page="page"
					@refetch:unread="fetchNumberOfUnread"
					@refetch:list="fetchNotifications"
					@next-page="page++"
					@previous-page="page--"
				/>
			</template>
		</v-popover>

		<!-- modal with subscriptions list -->
		<core-modal
			name="manageSubscriptionsModal"
			:headline="$t('notification_topics')"
		>
			<notifications-manage-topics class="bg5 p4" />
		</core-modal>
	</div>
</template>

<script>
import CoreModal from "@/modules/core/components/CoreModal"
import CrmIcon from "@/components/CrmIcon/"
import JButton from "@/components/JButton/"
import NotificationsList from "./NotificationsList"
import NotificationsManageTopics from "./NotificationsManageTopics"

import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default {
	components: {
		CoreModal,
		CrmIcon,
		JButton,
		NotificationsList,
		NotificationsManageTopics
	},

	data() {
		return {
			numberOfUnreadNotifications: 0,
			itemsPerPage: 5,
			page: 1,
			showMobileNotifications: false,
			listing: {
				list: [],
				numberOfItems: 0
			}
		}
	},

	created() {
		if (this.$store.state.settings.devFlags.hasNotifications) {
			this.loopOnFetchNotifications()
		}
	},

	computed: {
		logo() {
			return this.$store.state.settings.logo
				? this.$store.state.settings.logo
				: null
		},
		email() {
			return this.$store.state.email
		},
		username() {
			if (this.email === "admin@covergo.com") return "CoverGo Admin"
			else return this.$store.state.username
		}
	},

	methods: {
		// fetch periodically
		loopOnFetchNotifications() {
			this.fetchNotifications()
			this.fetchNumberOfUnread()
			setTimeout(this.loopOnFetchNotifications, 10000)
		},

		async fetchNumberOfUnread() {
			const query = gql`
				query numberOfUnread($where: notificationWhere) {
					me {
						associatedUser {
							notificationList(where: $where) {
								totalCount
							}
						}
					}
				}
			`
			const res = await api({
				query,
				variables: {
					where: { status_not: "READ" }
				}
			})

			this.numberOfUnreadNotifications =
				res?.data?.me?.associatedUser?.notificationList?.totalCount
		},

		async fetchNotifications() {
			const query = gql`
				query notifications(
					$limit: Int
					$skip: Int
					$sort: sortInput
					$where: notificationWhere
				) {
					me {
						associatedUser {
							notificationList(
								limit: $limit
								skip: $skip
								sort: $sort
								where: $where
							) {
								totalCount
								list {
									id
									status
									timestamp
									type
									internalMessage {
										dataJsonString
										renderedHtml
									}
								}
							}
						}
					}
				}
			`

			// Sorting - sort by createdAt
			const sort = { fieldName: "timeStamp", type: "desc" }

			// Pagination
			const skip = (this.page - 1) * this.itemsPerPage
			const limit = this.itemsPerPage

			this.isLoading = true
			const res = await api({
				query,
				variables: {
					skip,
					limit,
					sort
				}
			})
			this.isLoading = false

			// Check errors
			if (res.errors && res?.errors?.length)
				this.$store.dispatch("showError", [res.errors?.[0]?.message])

			this.listing.list =
				res?.data?.me?.associatedUser?.notificationList?.list || []
			this.listing.numberOfItems =
				res?.data?.me?.associatedUser?.notificationList?.totalCount || 0
		}
	}
}
</script>

<style scoped>
@import "../../../../assets/css/tokens.css";

.container-top-bar-wrapper {
	display: none;
	width: 100%;
	height: 56px;
	background-color: var(--color5);
	border-bottom: 1px solid var(--color7);
	z-index: 10;
}

.notifications-number {
	position: fixed;
	bottom: 112px;
	right: 10px;
	font-weight: 1000;
	background: red;
	color: white;
	height: 15px;
	padding: 3px;
	font-size: 7pt;
	border-radius: 5px;
}

.notifications-floating-button {
	position: fixed;
	bottom: 72px;
	right: 8px;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 56px;
	height: 56px;
	border-radius: 100%;
	border: solid 1px;
	border-color: var(--color7);
	background-color: var(--color4);
	color: var(--color1);
	font-size: var(--fontSize3);
	font-weight: var(--fontWeight7);
	user-select: none;
	cursor: pointer;
	z-index: 101;
}

@media (--md) {
	.container-top-bar-wrapper {
		display: flex;
	}
	.notifications-floating-button {
		display: none;
	}
	.notifications-number {
		position: static;
		margin-left: -6px;
		margin-top: -4px;
	}
}
</style>
